import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormContents from 'components/atoms/Form/FormContents';
import FormLabel from 'components/atoms/Form/FormLabel';
import BlockUI from 'components/molecules/BlockUi';
import DatePicker from 'components/molecules/DatePicker';
import OrganizationFilteredTree from 'components/organismos/organization/OrganizationFilteredTree/OrganizationFilteredTree';
import React from 'react';
import moment from 'moment';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import useMonthlyDailyReport from './hooks';
import MonthlyDailyTable from './MonthlyDailyTable';
import { Values } from 'utility/constants';
import { getOrgNameFromOrgOptionLabel } from 'utility/formatUtil';
import { getOrgTargetDates } from 'utility/orgTargetDateUtil';

const MonthlyDailyStoreLayout = () => {
  const {
    setCategoryAry,
    blocking,
    setBlocking,
    targetDate,
    setTargetDate,
    searchDate,
    searchDateForAggregation,
    staffCode,
    orgCode,
    setorgCode,
    orgName,
    functionType,
    monthlyDailyDetailList,
    monthlyDailyTotal,
    roleScreen,
    setOrgTreesOptions,
    taxExclude,
    setTaxExclude,
    toggle,
    setToggle,
    categoryOption,
    setCategoryOption,
  } = useMonthlyDailyReport();

  const targetPeriodData = `対象期間：${moment(searchDate.toDate ? new Date(searchDate.toDate) : targetDate).format(
    'YYYY/MM',
  )}`;
  const targetStoresData = `対象店舗：${getOrgNameFromOrgOptionLabel(orgName)}`;

  // 組織取得に渡す targetDay を決定する
  // 締日情報が取得できていればそれを利用し、期間内に現在日が含まれていれば当日を返す
  const getOrgTargetDays = () => {
    // 締日情報が取得できていればそれを利用
    if (searchDateForAggregation && searchDateForAggregation.fromDate && searchDateForAggregation.toDate) {
      const { from, to } = getOrgTargetDates(
        new Date(searchDateForAggregation.fromDate),
        new Date(searchDateForAggregation.toDate),
      );
      return { orgFrom: from, orgTo: to };
    }

    // フォールバック: 締日期間をそのまま利用
    if (searchDate.fromDate && searchDate.toDate) {
      const { from, to } = getOrgTargetDates(new Date(searchDate.fromDate), new Date(searchDate.toDate));
      return { orgFrom: from, orgTo: to };
    }

    // 最終フォールバック
    const { from, to } = getOrgTargetDates(targetDate, targetDate);
    return { orgFrom: from, orgTo: to };
  };
  const { orgFrom: orgTargetDayFrom, orgTo: orgTargetDayTo } = getOrgTargetDays();

  return (
    <>
      <BlockUI blocking={blocking}>
        <FormContents>
          <FlexBox>
            <FlexBoxItem width="100px">
              <FormLabel label="対象期間" />
            </FlexBoxItem>
            <FlexBoxItem>
              {searchDate.toDate ? (
                <DatePicker
                  dateFormat="yyyy年MM月"
                  date={new Date(searchDate.toDate)}
                  changeDate={(date: Date) => {
                    if (date !== null) {
                      setTargetDate(date);
                    }
                  }}
                  isFullWidth={false}
                  showMonthYearPicker={true}
                />
              ) : null}
            </FlexBoxItem>
          </FlexBox>

          {searchDate.fromDate && searchDate.toDate ? (
            <OrganizationFilteredTree
              functionType={functionType}
              staffCode={staffCode}
              orgLabel="店舗名"
              addAllItem={true}
              initOrgValue={String(orgCode)}
              orgCallback={(args: string | Array<string>) => {
                setorgCode(String(args));
              }}
              orgCategoryCallback={(args: Array<string>) => {
                setCategoryAry(args);
              }}
              initCatagory={(args: Array<string>) => {
                setCategoryOption(args);
              }}
              orgOrgOptionListCallback={setOrgTreesOptions}
              // 集計月が当月なら今日を開始/終了日に、それ以外は締日(start/end)を渡す
              targetdayForm={orgTargetDayFrom}
              targetdayTo={orgTargetDayTo}
              styles={{
                label: {
                  toggleSwitch: css({ marginLeft: '0px' }),
                },
                toggle: {
                  width: '19rem',
                  marginLeft: '0.4rem',
                },
              }}
              selectCheck={setToggle}
              defaultToggleValue={toggle}
              defaultCategoryValues={categoryOption}
              useV5Api={true}
            />
          ) : null}

          <FlexBoxItem
            customStyle={css({
              marginTop: toggle ? '10px' : '-20px',
              marginBottom: '8px',
            })}
          >
            <RadioSelectForm
              name="taxExclude"
              label="集計対象"
              labelInline={true}
              labelInlineWidth={100}
              items={Object.values(Values.TaxExclude)}
              value={String(taxExclude)}
              setValue={(e) => {
                setTaxExclude(Number(e.target.value));
              }}
            />
          </FlexBoxItem>

          <MonthlyDailyTable
            setBlocking={setBlocking}
            monthlyDailyDetailList={monthlyDailyDetailList}
            monthlyDailyTotal={monthlyDailyTotal}
            taxExclude={String(taxExclude)}
            targetPeriodData={targetPeriodData}
            targetStoresData={targetStoresData}
            roleScreen={roleScreen}
          />
        </FormContents>
      </BlockUI>
    </>
  );
};

export default MonthlyDailyStoreLayout;
